<template>
    <v-card
        flat
        rounded
        :class="background"
        :ripple="false"
    >
        <div class="lm-border pa-3 pt-3" style="height: 90px" >
            <div class="v-flex" style="justify-content: space-between">
                <div style="margin-top: -3px; margin-left: -6px;" v-if="selected ||deleteable">
                    <a @click="onMinus">
                        <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                    </a>
                </div>
                <div style="font-size: 15px; padding-top: 1px;">
                    <span
                        :class="active ? 'primary--text' : 'lightgray'"
                    >
                        {{ site.fabricNo }}
                    </span>
                </div>
                <div
                    v-if="site.limSince"
                    class="pl-1 secondary--text"
                    style="font-size: 13px; padding-top: 3px;"
                >
                    seit {{ date (site.limSince) }}
                </div>
                <v-spacer/>
                <div class="site-customer">
                   <span v-if="site.contracttype">{{ site.contracttype }} - </span><span>{{ site.customer.name }}</span>
                </div>
                <div style="margin-top: -2px; margin-right: -7px;">
                    <c-site-icon
                        :site="site"
                        @selected="onSite(site)"
                    />
                </div>
            </div>
            <div class="card-subtitle" style="margin-top: -6px;">
                {{ site.street }}, {{ site.zip }} {{ site.city }}
            </div>
            <div class="card-subtitle">
                {{ site.ve }}  {{ site.ve && site.ve2 ? ' / ' : ''  }}  {{ site.ve2 }}
            </div>
        </div>
    </v-card>
</template>

<script>

import Core from "@/modules/core/service/Core";
import CSiteIcon from "@/modules/msd/unit/components/controlls/CSiteIcon";
import Site from "@/modules/msd/unit/service/Site";

export default {
    name: "CSiteCardDense",
    components: {
        CSiteIcon
    },
    props: {
        site: {

        },

        selected: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        deleteable: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
    },


    data: () => ({
        showMenu : false
    }),


    computed: {
        active () {
            if (!this.site.status) {
                return false;
            }

            return this.site.status.id === 1;
        },


        background () {
            return this.selected ? "background-selected" : "";
        },

        contract () {
            if (!this.site.contract) {
                return null;
            }

            switch (this.site.contract.type.id) {
                case Site.CONTRACT.LIM:
                    return "LIM";
                case Site.CONTRACT.DLS:
                    return "DLS";
            }

            return null;
        }
    },

    methods: {
        onSite (site) {
            if (site) {
                this.$emit("site", site)
            }
        },

        onMinus () {
            this.$emit("deselect", this.site);
        },

        date (value) {
            return Core.format.date.display(value);
        },
    }
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.site-customer {
    font-size: 13px;
    padding-right: 5px;
    padding-top: 4px;
    max-width: 175px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

</style>